// extracted by mini-css-extract-plugin
export default {"DashboardPage":"DashboardPage_DashboardPage__MV1Wx"};